import actionTypes from '../actions/actionTypes';
function reducer(state = [], action) {
  switch (action.type) {
    case actionTypes.JOB_COMMENT_CREATED:
    case actionTypes.JOB_COMMENT_UPDATED:
    case actionTypes.JOB_COMMENT_DELETED:
      return state ? [...state, action.job] : state;
    default:
      return state;
  }
}
export default reducer;
